import { ObjectIdentityTitle } from "../ObjectIdentityTitle";
import { withTimeSystem } from "../../constants/orbitMetadata";
import { formatDate } from "./eventEvolutionUtils";

interface EventMiniObjectProps {
  objectId?: string;
  cospar?: string;
  name?: string;
  norad?: string;
  sourceOfInformation?: string;
  updateTime?: string;
}

export const EventMiniObject = ({
  objectId,
  cospar,
  name,
  norad,
  sourceOfInformation,
  updateTime,
}: EventMiniObjectProps) => (
  <ObjectIdentityTitle
    cospar={cospar}
    objectId={objectId}
    linkToObject
    meta={`${
      sourceOfInformation ? `${sourceOfInformation} | ` : ""
    }${withTimeSystem("Update Time")}: ${formatDate(updateTime)}`}
    metaTitle={updateTime}
    name={name}
    norad={norad}
    variant="compact"
  />
);
